import { render, staticRenderFns } from "./UserDashboardFacilities.vue?vue&type=template&id=fd960798&scoped=true&"
import script from "./UserDashboardFacilities.vue?vue&type=script&lang=js&"
export * from "./UserDashboardFacilities.vue?vue&type=script&lang=js&"
import style0 from "./UserDashboardFacilities.vue?vue&type=style&index=0&id=fd960798&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd960798",
  null
  
)

export default component.exports